import { render, staticRenderFns } from "./ListIndex.vue?vue&type=template&id=52f7d611&scoped=true&"
import script from "./ListIndex.vue?vue&type=script&lang=ts&"
export * from "./ListIndex.vue?vue&type=script&lang=ts&"
import style0 from "./ListIndex.vue?vue&type=style&index=0&id=52f7d611&lang=less&scoped=true&"
import style1 from "./ListIndex.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f7d611",
  null
  
)

export default component.exports